import BaseBusinessAPI from '../portal/baseBusinessAPI'

class TenantAPI extends BaseBusinessAPI {
  controllerName = 'Tenants';

  /**
   * @description Lấy dữ liệu domain đang trỏ vào cổng tuyển sinh của phòng giáo dục hay trường
   * @param {*} payload
   * @returns
   */
  getTenantBySGDTenantCode (payload) {
    let urlParam = `${payload.sgdTenantCode}`
    if (payload?.tenantCode) {
      urlParam += `/${payload.tenantCode}`
    }
    const request = {
      url: this.getAPIUrl(urlParam),
    }

    return this.getAsync(request)
  }

  /**
   * @description Lấy thông tin chi tiết của một trường
   * @param {*} payload
   * @returns
   */
  getEnrollmentOnlineByTenantId (payload) {
    const request = {
      url: this.getAPIUrl('detail'),
      data: payload,
    }
    return this.getAsync(request)
  }
}

export default new TenantAPI()
